import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import layoutStyle from "../../style/layout.module.less";
import { NavBar } from "./Navbar";
import { SolstackFooter } from "./Footer";
import { Home } from "../home/home";
import { NotFound } from "../NotFound";
import { About } from "../about/About";

export const SolstackLayout = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`${layoutStyle.shell}${scrolled ? " layout-scrolled" : ""}`}>
      <header className={layoutStyle.header}>
        <NavBar />
      </header>

      <main className={layoutStyle.main}>
        <Routes>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <SolstackFooter />
    </div>
  );
};
